import get from "lodash/get";
import set from "lodash/set";
import unset from "lodash/unset";

function updateUnits(obj, preferred) {
  if (!("_percents" in obj)) return;
  const keys = obj._percents;
  delete obj._percents;
  if (!Array.isArray(keys)) return;

  // Go over dates and parse them from plain text into js dates.
  keys.forEach(function (key) {
    const value = parseInt(get(obj, key), 10);
    if (isNaN(value)) unset(obj, key);
    else set(obj, key, value);
  });

  return obj;
}

export default updateUnits;
